import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Typography, Box, Paper, Grid } from '@mui/material';

import MyAppBar from '../components/MyAppBar';
import DatePicker from '../components/DatePicker';
import PermitteeTable from '../components/PermitteeTable';
import Appendices from '../components/Appendices';

const MONTHS = [
  '',
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const styles = {
  main: {
    backgroundColor: '#eeeeee',
    margin: 0,
    padding: 0,
    // height: '100vh'
  },
  title: {
    flexGrow: 1,
  },
  container: {
    flex: 1,
    padding: 1,
  },
  paper: {
    margin: 2,
    padding: 1,
    width: '100%',
  },
  footer: {
    // padding: 50,
    marginTop: 'auto',
  },
};

export default function Home(props) {
  const params = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [permittees, setPermittees] = useState([]);
  const [year, setYear] = useState(new Date().getFullYear());
  const [month, setMonth] = useState('');
  const [hideControls, setHideControls] = useState(false);

  useEffect(() => {
    console.log('params: ', params);
    const { yearmonth } = params;
    console.log(`yearmonth:`, yearmonth);
    if (yearmonth) {
      const [paramYear, paramMonth, paramOnly] = yearmonth?.split('-');
      setYear(paramYear);
      setMonth(paramMonth);
      setHideControls(!!paramOnly);
      getPermittees({ year: paramYear, month: paramMonth });
    }
  }, [params]);

  const getPermittees = async ({ year, month }) => {
    console.log(`getPermittees for ${year}-${month}`);
    setPermittees([]);
    if (month && year) {
      setLoading(true);
      const { apiUrl } = window['config'];
      const response = await fetch(
        `${apiUrl}/person/permittee/date/${year}-${month}`
      );
      const permittees = await response.json();

      console.log(permittees);
      setPermittees(permittees);
      setLoading(false);
    }
  };

  const handleClick = (permittee) => (event) => {
    navigate(
      `/permit?permittee=${encodeURIComponent(
        permittee.NAME
      )}&permits=${permittee.permits.join(',')}&year=${year}&month=${month}`
    );
  };

  return (
    <React.Fragment>
      <MyAppBar
        title='Permit Recommendations'
        permittees={permittees}
        year={year}
        month={month}
      />
      <Container sx={styles.container}>
        <Grid
          container
          direction='column'
          justifyContent='flex-start'
          alignItems='center'
        >
          {/* <Grid item>{`props.hideControls: ${props.hideControls}`}</Grid> */}
          <Grid item>
            {!props.hideControls ? (
              <Box>
                <DatePicker defaultYear={year} defaultMonth={month} />
              </Box>
            ) : (
              <Typography variant='h4'>{`${MONTHS[month]} ${year}`}</Typography>
            )}
          </Grid>
          <Grid item sx={{ width: '100%' }}>
            <Box>
              <Paper sx={styles.paper}>
                <PermitteeTable
                  onClick={handleClick}
                  data={permittees}
                  year={year}
                  month={month}
                  loading={loading}
                />
              </Paper>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Box sx={styles.footer}>
        {year !== '' && month !== '' ? (
          <Appendices year={year} month={month} />
        ) : null}
      </Box>
    </React.Fragment>
  );
  // }
}
